export default {"src":"/_next/static/media/BitYacht.17b77182.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};